import { render, staticRenderFns } from "./Waiting_test.vue?vue&type=template&id=6d684de4&style=height%3A%20100%25%3B"
import script from "./Waiting_test.vue?vue&type=script&lang=js"
export * from "./Waiting_test.vue?vue&type=script&lang=js"
import style0 from "./Waiting_test.vue?vue&type=style&index=0&id=6d684de4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports